import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const COLORS = ["bg-violet-100 text-violet-700", "bg-emerald-100 text-emerald-700", "bg-amber-100 text-amber-800", "bg-sky-100 text-sky-700", "bg-rose-100 text-rose-700", "bg-teal-100 text-teal-700"];

const initials = (name = "") => name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
const color = (s = "") => COLORS[[...s].reduce((a, c) => a + c.charCodeAt(0), 0) % COLORS.length];

export const UserAvatar = ({ user, size = "h-9 w-9", testId }) => (
  <Avatar className={`${size} shrink-0`} data-testid={testId}>
    {user?.picture && <AvatarImage src={user.picture} alt={user.name} referrerPolicy="no-referrer" data-testid={testId && `${testId}-img`} />}
    <AvatarFallback className={`text-xs font-bold ${color(user?.email || user?.name)}`}>{initials(user?.name)}</AvatarFallback>
  </Avatar>
);
